import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import { useHistory } from 'react-router-dom'
import { FETCH_OFFERS_DETAILS } from '../../redux/OffersDetails';
import { SET_VEHICLE_TYPE_NO_EFFECT } from '../../redux/VehicleTypeReducer';
import { compose } from 'redux';
import { createUseStyles } from 'react-jss';
import { navigationMapping } from '../../consts/navigation';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';


const RedirectToOfferContainer = ({ t, fetchOffersDetails, setVehicleType, vehicleType, offer, match: { params: { offerId, }, }, }) => {
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    fetchOffersDetails(offerId);
  }, [fetchOffersDetails, offerId])

  useEffect(() => {
    if (Object.keys(offer).length !== 0) {
      setVehicleType(offer.vehicle_type);
    }
  }, [setVehicleType, offer])

  useEffect(() => {
    if (Object.keys(offer).length === 0 && vehicleType) {
      return
    }
    if (offer.current_navigation_folder === 'error') {
        history.push({ state: { whichFolder: offer.current_navigation_folder, }, });
    } else {
        history.push({ pathname: `${navigationMapping[offer.current_navigation_folder].details_url}/${offer.hash_id}`,
                       state: { whichFolder: offer.current_navigation_folder, }, });
    }
  }, [offer, vehicleType, history])

  return (
    <div>
      {Object.keys(offer).length !== 0 &&
        <div className={classes.banner}>
          {t('offer_not_available')}
        </div>
      }
    </div>
  )
};

const useStyles = createUseStyles({
  banner: {
    width: '80%',
    backgroundColor: '#ddf3fc',
    margin: [30, 'auto'],
    textAlign: 'center',
    padding: 50,
  },
})


const mapStateToProps = (state) => {
  return {
    vehicleType: state.vehicleType.vehicleType,
    offer: state.offerDetails.data,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    fetchOffersDetails: (offerId) => dispatch(FETCH_OFFERS_DETAILS(offerId)),
    setVehicleType: (vehicleType) => dispatch(SET_VEHICLE_TYPE_NO_EFFECT(vehicleType)),
  };
};

RedirectToOfferContainer.propTypes = {
  offer: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  offerId: PropTypes.string.isRequired,
  fetchOffersDetails: PropTypes.func.isRequired,
  setVehicleType: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  vehicleType: PropTypes.string.isRequired,
};


export default compose(
  withRouter,
  withScopedTranslations('offer_details'),
  connect(mapStateToProps, mapDispatchToProps)
)(RedirectToOfferContainer)
